import { ReactNode } from 'react'

import { Accordion } from '@tribeplatform/react-ui-kit/Accordion'
import { SimpleDivider } from '@tribeplatform/react-ui-kit/Divider'

import { T } from '../../i18n/index.js'

import { GenericSettings } from './GenericSettings.js'

interface GenericViewSettingsProps {
  title: string
  children: ReactNode
  goBack: () => void
}
export const GenericViewSettings = ({
  title,
  children,
  goBack,
}: GenericViewSettingsProps) => {
  return (
    <GenericSettings
      title={title}
      description={
        <T
          defaultMessage="Selected tab view settings"
          id="MultiViewBlock.ViewSettings.Selected"
        />
      }
      goBack={goBack}
    >
      {children}
    </GenericSettings>
  )
}

interface HocProps {
  children: ReactNode
}
const SectionHOC = (title: JSX.Element, defaultOpen?: boolean) => {
  return ({ children }: HocProps) => {
    return (
      <>
        <SimpleDivider variant="subdued" />
        <Accordion
          defaultOpen={defaultOpen}
          iconAlign="trailing"
          className="-mx-2"
        >
          <Accordion.Button noHover className="hover:text-content-hovered">
            {title}
          </Accordion.Button>
          <Accordion.Panel>
            <div className="space-y-5">{children}</div>
          </Accordion.Panel>
        </Accordion>
      </>
    )
  }
}

GenericViewSettings.Source = SectionHOC(
  <T defaultMessage="Source" id="Generics.Source" />,
  true,
)
GenericViewSettings.Filters = SectionHOC(
  <T defaultMessage="Filters" id="Generics.Filters" />,
)
GenericViewSettings.Sort = SectionHOC(
  <T defaultMessage="Sort" id="Generics.Sort.Noun" />,
)
GenericViewSettings.Layout = SectionHOC(
  <T defaultMessage="Layout" id="Generics.Layout" />,
)
GenericViewSettings.Fields = SectionHOC(
  <T defaultMessage="Fields" id="Generics.Fields" />,
)
